import { RotationPlayerInfo } from '@/entities/rotations/RotationsInfo';

interface BlurredLineupsProps {
	rotations: RotationPlayerInfo[];
	showBothPlayers?: boolean;
}

export const BlurredLineupsCard = ({ rotations, showBothPlayers }: BlurredLineupsProps) => {
	return (
		<div className="mt-4 flex flex-col gap-4 max-w-full">
			{rotations.map((player, index) => {
				const names = showBothPlayers ? [player.playerOneName, player.playerTwoName].filter(Boolean) : [player.playerOneName];

				return (
					<div key={`${player.playerOneUuid}`} className="flex items-center gap-3 blur-[3px]">
						<span className="w-6 h-6 flex items-center justify-center aspect-square rounded-full border border-gray-400 text-sm">
							{index + 1}
						</span>

						<div className="flex flex-col w-full leading-tight">
							{names.map((_, i) => (
								<span key={i} className="relative inline-block blur-[3px] select-none pointer-events-none text-gray-900">
									Hidden player
								</span>
							))}
						</div>
					</div>
				);
			})}
		</div>
	);
};
